import { Capacitor } from '@capacitor/core';

const isGranted = (status) => status === 'granted' || status === 'limited';

export async function requestAppPermissions() {
  if (!Capacitor.isNativePlatform()) {
    return { camera: 'granted', photos: 'granted', location: 'granted' };
  }

  const result = { camera: 'prompt', photos: 'prompt', location: 'prompt' };

  try {
    const { Camera } = await import('@capacitor/camera');
    const current = await Camera.checkPermissions();
    const cam = isGranted(current.camera) && isGranted(current.photos)
      ? current
      : await Camera.requestPermissions({ permissions: ['camera', 'photos'] });
    result.camera = cam.camera;
    result.photos = cam.photos;
  } catch (error) {
    console.warn('Camera/photos permission request failed:', error);
  }

  try {
    const { Geolocation } = await import('@capacitor/geolocation');
    const current = await Geolocation.checkPermissions();
    const geo = isGranted(current.location) || isGranted(current.coarseLocation)
      ? current
      : await Geolocation.requestPermissions();
    result.location = geo.location || geo.coarseLocation;
  } catch (error) {
    console.warn('Location permission request failed:', error);
  }

  return result;
}

export async function ensureCameraPermission() {
  if (!Capacitor.isNativePlatform()) return true;
  try {
    const { Camera } = await import('@capacitor/camera');
    const current = await Camera.checkPermissions();
    if (isGranted(current.camera)) return true;
    const requested = await Camera.requestPermissions({ permissions: ['camera'] });
    return isGranted(requested.camera);
  } catch (error) {
    console.warn('Camera permission check failed:', error);
    return true;
  }
}
